import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { TickerProvider } from './context/TickerContext';
import ProfileLoader from './components/layout/ProfileLoader';
import ActivityTracker from './components/layout/ActivityTracker';

import store, { persistor } from './store';
import router from './router/router';
import { useNightMode } from './theme/useNightMode';

const queryClient = new QueryClient();

function App() {
    // Using a loading state to indicate when PersistGate has finished
    const [persistLoaded, setPersistLoaded] = useState(false);
    const { night } = useNightMode();

    return (
        <StoreProvider store={store}>
            <PersistGate
                persistor={persistor}
                loading={null}
                onBeforeLift={() => setPersistLoaded(true)}
            >
                <QueryClientProvider client={queryClient}>
                    <TickerProvider>

                        {persistLoaded && (
                            <>
                                <ProfileLoader />
                                <ActivityTracker />
                                <RouterProvider router={router} />
                            </>
                        )}

                    </TickerProvider>
                </QueryClientProvider>
            </PersistGate>
            <ToastContainer
                autoClose={2000}
                position="top-right"
                theme={night ? 'dark' : 'light'}
            />
        </StoreProvider>
    );
}

export default App;
